import { useState, useEffect, useCallback } from "react";
import {
  useHotkeyContext,
  HotkeyId,
} from "components/scrapEyeDataDashboard/VideoPlayer/contexts/HotkeyContext";
import { Hotkey } from "./Hotkey";

export const EditableHotkey = ({ hotkeyId }: { hotkeyId: HotkeyId }) => {
  const { getDisplayKey, setHotkey } = useHotkeyContext();
  const [waitingForInput, setWaitingForInput] = useState(false);

  const handleClick = useCallback(() => {
    setWaitingForInput(true);
  }, []);

  useEffect(() => {
    if (!waitingForInput) return;

    const handleKeyPress = (event: KeyboardEvent) => {
      event.preventDefault();
      event.stopPropagation();

      const key = event.code;
      setHotkey(hotkeyId, key);
      setWaitingForInput(false);
    };

    document.addEventListener("keydown", handleKeyPress, true);

    return () => {
      document.removeEventListener("keydown", handleKeyPress, true);
    };
  }, [waitingForInput, hotkeyId, setHotkey]);

  const displayKey = getDisplayKey(hotkeyId);
  const label = waitingForInput ? "..." : displayKey;

  return (
    <Hotkey
      label={label}
      waitingForInput={waitingForInput}
      onClick={handleClick}
    />
  );
};
